import HttpService from "@core/services/http/http.service";
import { RequestParams, Signal } from "@core/services/http/http.type";
import { GetDetailResponse, GetListResponse } from "@app/types";
import { BookTimeFrame, BookTimeFrameCreate } from "@app/types/book-time-frame.type";

class _BookTimeFrameService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<BookTimeFrame>>("/admin/api/v3/book-time-frames", {
      queryParams: { ...requestParams },
      signal,
    });
  }

  public get(id: number) {
    return HttpService.get<GetDetailResponse<BookTimeFrame>>(
      `/admin/api/v3/book-time-frames/${id}`,
    );
  }

  public create(bookTimeFrame: BookTimeFrameCreate) {
    return HttpService.post("/admin/api/v3/book-time-frames", {
      body: { ...bookTimeFrame },
    });
  }

  public update(id: number, bookTimeFrame: BookTimeFrameCreate) {
    return HttpService.patch(`/admin/api/v3/book-time-frames/${id}`, {
      body: { ...bookTimeFrame },
    });
  }

  public delete(id: number) {
    return HttpService.delete(`/admin/api/v3/book-time-frames/${id}`);
  }
}

const BookTimeFrameService = new _BookTimeFrameService();

export default BookTimeFrameService;
